module.exports = __webpack_public_path__ + "static/media/10.1eae1ef6.jpg";